import type { paths } from '@pba/types-openapi-node';
import type { AxiosResponse } from 'axios';
import { getNodeApiAxiosInstance } from '#client';
import type { ConfigRequest, PaginationDataObject } from '#models';
import type { UserDataObject } from '#models/services';
import { routes } from '#routes';

export type FindUsersRequest = paths['/users']['get']['requestBody']['content']['application/json'];

type FindUsersDataObject = PaginationDataObject<UserDataObject>;

export const findUsers = async ({ config }: ConfigRequest<FindUsersRequest>) =>
  getNodeApiAxiosInstance().get<FindUsersDataObject, AxiosResponse<FindUsersDataObject>>(routes.users.find, config);
